import isEmail from 'validator/es/lib/isEmail';

import { isValidPhoneNumber } from 'libphonenumber-js';

export const required = (message: string) => (value: string | number) =>
  value || typeof value === 'number' ? undefined : message;

export const requiredArray = (message: string) => (value: unknown[]) => value.length ? undefined : message;

export const atLeastOneLowerCase = (message: string) => (value: string) => {
  if (!value) return undefined;

  return value && value.match(/([a-z])+/gm) ? undefined : message;
};

export const atLeastOneUpperCase = (message: string) => (value: string) => {
  if (!value) return undefined;

  return value && value.match(/([A-Z])+/gm) ? undefined : message;
};
export const atLeastOneDigit = (message: string) => (value: string) => {
  if (!value) return undefined;

  return value && value.match(/(\d)+/gm) ? undefined : message;
};

export const atLeastOneNonWordCharacter = (message: string) => (value: string) => {
  if (!value) return undefined;

  return value && value.match(/(?=.*\W)/) ? undefined : message;
};

export const username = (message: string) => (value: string) =>
  value && value.match(/^[\w.@+-]+$/gm) ? undefined : message;

export const maxNumber =
  (message: string, max: string | number = Infinity) =>
  (value: string | number) =>
    (value || typeof value === 'number') && Number(value) <= max ? undefined : `${message} ${max}`;

export const minNumber =
  (message: string, min: string | number = Infinity) =>
  (value: string | number) =>
    (value || typeof value === 'number') && Number(value) >= min ? undefined : `${message} ${min}`;

export const minMaxLength =
  ({ min = -Infinity, max = Infinity }: { min?: number; max?: number }, message: string) =>
  (value: string | Array<unknown>) => {
    if (!value) return undefined;
    return value && value.length >= min && value.length <= max ? undefined : message;
  };

export const textMaxLength = (max: number, message: string) => (value: string) => {
  if (!value) return undefined;
  return value && value.length <= max ? undefined : `${message} ${value.length}/${max}`;
};

export const equal = (comparedValue: string | number | undefined, message: string) => (value: string | number) => {
  return value && value === comparedValue ? undefined : message;
};

export const email = (message: string) => (value: string) => value && !isEmail(value) ? message : undefined;

export const phoneNumber = (message: string) => (value: string) =>
  value && !isValidPhoneNumber(value) ? message : undefined;

export const isInteger = (message: string) => (v: string | number) => Number.isInteger(Number(v)) ? undefined : message;

export const isFloat = (message: string, availableDecimalPlaces: number) => (v: string) => {
  const decimalPlaces = v.split('.')?.[1]?.length;
  if (decimalPlaces && (decimalPlaces > availableDecimalPlaces || decimalPlaces === 0)) {
    return message;
  }

  return undefined;
};
